export const FORA_SOURCE = 'FORA';

export const SOURCE_TYPE_FILE = 'F';
export const SOURCE_TYPE_MANUAL = 'M';
